import PropTypes from 'prop-types'
import React from 'react'

const getViewerUrl = url =>
  `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(
    url
  )}`

class PdfViewer extends React.Component {
  constructor(props) {
    super(props)

    this.ref = null

    this.setIframeRef = this.setIframeRef.bind(this)
  }

  // eslint-disable-next-line class-methods-use-this
  shouldComponentUpdate() {
    return false
  }

  setIframeLoading() {
    const paragraph = document.createElement('p')
    paragraph.innerHTML = '<p>Caricamento in corso...</p>'

    this.ref.contentDocument.body.appendChild(paragraph)
  }

  setIframeStyle() {
    const style = document.createElement('style')
    style.type = 'text/css'
    style.innerHTML = ''

    this.ref.contentDocument.head.appendChild(style)
  }

  setIframeReload() {
    this.ref.contentWindow.setInterval(() => {
      if (!this.props.url) {
        return
      }

      const viewerUrl = getViewerUrl(this.props.url)

      this.ref.contentWindow.location.href = viewerUrl

      this.ref.contentDocument.body.innerHTML = `
        <p>Se hai problemi a visualizzare clicca <a href="${viewerUrl}" target="_self">qui</a>.</p>
      `
    }, 2000)
  }

  setIframeRef(ref) {
    this.ref = ref

    if (this.ref) {
      this.setIframeStyle()

      this.setIframeLoading()

      this.setIframeReload()
    }
  }

  render() {
    return (
      <div className="pdf-viewer">
        <Iframe ref={this.setIframeRef} />
      </div>
    )
  }
}

PdfViewer.propTypes = {
  url: PropTypes.string.isRequired,
}

export default PdfViewer
